module.exports = __webpack_public_path__ + "img/home_automatic.8295bffe.webp";